import { render, staticRenderFns } from "./registerAme.vue?vue&type=template&id=64cd6d6e"
import script from "./registerAme.vue?vue&type=script&lang=js"
export * from "./registerAme.vue?vue&type=script&lang=js"
import style0 from "./registerAme.vue?vue&type=style&index=0&id=64cd6d6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports